__turbopack_context__.v({
  "alignRight": "Modal-module__7xAXIW__alignRight",
  "alignRightContent": "Modal-module__7xAXIW__alignRightContent",
  "closeBtn": "Modal-module__7xAXIW__closeBtn",
  "closeNBtn": "Modal-module__7xAXIW__closeNBtn",
  "darkBg": "Modal-module__7xAXIW__darkBg",
  "filled": "Modal-module__7xAXIW__filled",
  "fullViewBackdrop": "Modal-module__7xAXIW__fullViewBackdrop",
  "fullViewMobile": "Modal-module__7xAXIW__fullViewMobile",
  "light": "Modal-module__7xAXIW__light",
  "modalContent": "Modal-module__7xAXIW__modalContent",
  "modalContentSlideUp": "Modal-module__7xAXIW__modalContentSlideUp",
  "modalFadeIn": "Modal-module__7xAXIW__modalFadeIn",
  "root": "Modal-module__7xAXIW__root",
  "top": "Modal-module__7xAXIW__top",
});
